import { ApostleClassType as n, ApostleClassId as o, ApostleSourceType as t, ApostleStatus as s, ApostleTicketStatus as r, ApostleSkillType as u, ApostleTicketItemType as i, ApostleTicketType as f, ReservedApostleState as d, ReservedApostleSlotState as c } from "../../constants/apostle.js";
import { listingInfoSchema as k, listingStatusSchema as g } from "../../../common-lib/deserializes/yup/listingInfo.js";
import { currencyTokenLiteSchema as y } from "../../../currency-lib/deserialize/yup/currency.js";
import { publicAccountSchema as h } from "../../../temp-lib/deserialize/yup/account.js";
import * as e from "yup";
const m = e.mixed().oneOf(Object.values(n)).default(n.Berserker), v = e.mixed().oneOf(Object.values(o)).default(o.Berserker), p = e.mixed().oneOf(Object.values(t)).default(t.None), T = e.object({
  icon: e.string().default(""),
  name: e.string().default(""),
  type: m
}).noUnknown(!0), j = e.mixed().oneOf(Object.values(s)).default(s.Enable), x = e.mixed().oneOf(Object.values(r)).default(r.Enable), A = e.mixed().oneOf(Object.values(u)).default(u.ActiveSkill), b = e.object({
  id: e.number().default(0),
  key: e.string().default(""),
  level: e.number().default(0)
}).from("skillID", "id"), I = e.mixed().oneOf(Object.values(i)).default(i.Unknown), O = e.mixed().oneOf(Object.values(f)).default(f.Warrior), w = e.mixed().oneOf(Object.values(d)).default(d.Reserved), M = e.mixed().oneOf(Object.values(c)).default(c.Reserved), U = e.object({
  costume: e.string().default(""),
  ivMax: e.number().default(0),
  ivMin: e.number().default(0),
  skillLevelMax: e.number().default(0),
  skillLevelMin: e.number().default(0),
  className: e.string().default("")
}).camelCase().noUnknown(!0), C = e.object({
  attack: e.number().default(0),
  attackRange: e.number().default(0),
  attackSpeed: e.number().default(0),
  criticalChance: e.number().default(0),
  criticalDamage: e.number().default(0),
  defense: e.number().default(0),
  health: e.number().default(0),
  intelligence: e.number().default(0),
  moveSpeed: e.number().default(0),
  resistance: e.number().default(0)
}).noUnknown(!0), S = e.object({
  class: T,
  disabled: e.boolean().default(!1),
  image: e.string().default(""),
  id: e.string().default(""),
  iv: e.number().default(0),
  selected: e.boolean().default(!1),
  skillExps: e.array().of(b).default([]),
  sourceType: p
}).noUnknown(!0), L = e.object({
  api: e.string().default(""),
  disabled: e.boolean().default(!1),
  id: e.string().default(""),
  image: e.string().default(""),
  itemType: I,
  iv: e.number().default(0),
  level: e.number().default(0),
  name: e.string().default(""),
  quantity: e.number().default(0),
  randomFactor: U,
  selected: e.number().default(0),
  skillExps: e.array().of(b).default([]),
  status: x,
  type: O,
  color: e.string().default("")
}).from("item_type", "itemType").from("random_factor", "randomFactor").noUnknown(!0), N = S.concat(
  e.object({
    cooldownNow: e.boolean().default(!1),
    reservedAt: e.string().default(""),
    sameTypeSelected: e.boolean().default(!1),
    selected: e.boolean().default(!1),
    slotState: M,
    sourceType: p.default(t.None),
    state: w
  })
).from("activeSkillsEXP", "skillExps").from("dungeonApostleID", "id").from("classType.class", "class").noUnknown(!0), R = e.object({
  cardType: e.string().default(""),
  class: m,
  description: e.string().default(""),
  descriptionShort: e.string().default(""),
  disabled: e.boolean().default(!1),
  image: e.string().default(""),
  key: e.string().default(""),
  level: e.number().default(0),
  mana: e.number().transform((l) => isNaN(l) ? 0 : l).default(0),
  name: e.string().default(""),
  type: A,
  uniqueKey: e.string().default("")
}).from("card_type", "cardType").from("desc_short", "descriptionShort").from("desc", "description").from("name", "name").from("skill_class", "class").from("skill_id", "key", !0).from("skill_id", "uniqueKey").from("skill_type", "type").noUnknown(!0), q = e.object({
  startAt: e.string().default(""),
  endAt: e.string().default(""),
  prices: e.array().of(
    y.from("currencyCode", "type").from("price", "amount").noUnknown(!0)
  ).default([]),
  tickets: e.array().of(L).default([]),
  maxMintLimit: e.number().default(0)
}).from("mintInfo.priceList", "prices").from("mintInfo.beginTime", "startAt").from("mintInfo.endTime", "endAt").from("mintInfo.ticketID", "tickets").from("mintInfo.maxMintLimit", "maxMintLimit").noUnknown(!0), a = S.concat(
  e.object({
    classId: v,
    listingInfo: k.nullable(!0).default(null),
    listingStatus: g,
    name: e.string().default(""),
    redStatus: e.boolean().default(!1),
    reforgeCount: e.number().default(0),
    status: j,
    statusText: e.string().default("")
  })
).from("apostleID", "id").from("skills", "skillExps").from("class", "classId").from("metaKey.class", "class").from("ticketMint", "sourceType").from("nftListingStatus", "listingStatus").noUnknown(!0), B = a.concat(
  e.object({
    bookmarked: e.boolean().default(!1),
    level: e.number().default(0),
    name: e.string().default(""),
    owner: h.nullable(!0).default(null),
    stats: C
  })
).noUnknown(!0), K = e.object({
  seasonMintType: e.number().default(0),
  walletAddress: e.string().default(""),
  apostleClass: e.array().of(e.number()).default([]),
  apostleGene: e.array().of(e.string()).default([]),
  apostleIV: e.array().of(e.string()).default([]),
  timestamp: e.number().default(0),
  isFreeMint: e.array().of(e.boolean()).default([]),
  freeMintTotalCount: e.number().default(0),
  signature: e.string().default(""),
  maxSlotMintCount: e.number().default(0)
}).noUnknown(!0), P = e.object({
  beforeForge: a.nullable(),
  afterForge: a.nullable(),
  apostleId: e.string().default("")
}).from("apostleID", "apostleId").noUnknown(!0);
export {
  S as apostleBaseSchema,
  a as apostleLiteSchema,
  q as apostleMintSchema,
  P as apostleReforgePreviewSchema,
  B as apostleSchema,
  K as apostleSignedSeasonMintSchema,
  R as apostleSkillSchema,
  L as apostleTicketSchema,
  N as reservedApostleSchema
};
//# sourceMappingURL=apostle.js.map
